<div class="widget-container" [style.height.px]="containerHeight()" [style.width.px]="containerWidth()">
  @if (widgetConfig(); as config) {
    <dojo-widget [config]="config" />
  }

  @if (editor().isEditable) {
    <dojo-button
      class="widget-edit-button"
      fill="clear"
      (click)="toggleEditor(); $event.stopPropagation()"
      title="Edit widget config"
    >
      <dojo-icon icon="gear" [size]="16" />
    </dojo-button>
    @if (isResizable()) {
      <div class="resize-handle-bottom" (mousedown)="resizeHeight($event)"></div>
      <div class="resize-handle-right" (mousedown)="resizeWidth($event)"></div>
      <div class="resize-handle-corner" (mousedown)="resizeCorner($event)"></div>
    }
  }
</div>

@if (showEditor() && editor().isEditable) {
  <!-- Stop all keyboard/clipboard/input events from reaching Tiptap -->
  <div
    (keydown)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()"
    (keypress)="$event.stopPropagation()"
    (beforeinput)="$event.stopPropagation()"
    (paste)="$event.stopPropagation()"
    (copy)="$event.stopPropagation()"
    (cut)="$event.stopPropagation()"
  >
    <dojo-draggable-pane
      [options]="editorPaneOptions()"
      wrapperClass="!top-0 !left-0 flex-col !gap-0"
      contentClass="widget-editor-panel"
    >
      <div slot="drag-handle" class="widget-editor-handle">
        <div class="flex items-center gap-2">
          <span>Widget Config</span>
          @if (hasVisualEditor()) {
            <mat-button-toggle-group
              class="custom-toggle-group size-xs"
              hideSingleSelectionIndicator
              [value]="editorMode()"
              (change)="editorMode.set($event.value)"
            >
              <mat-button-toggle value="json">JSON</mat-button-toggle>
              <mat-button-toggle value="visual">Visual</mat-button-toggle>
            </mat-button-toggle-group>
          }
        </div>
        <dojo-button class="widget-editor-close" fill="clear" (click)="toggleEditor(); $event.stopPropagation()">
          <dojo-icon icon="xmark" [size]="14" />
        </dojo-button>
      </div>
      <div class="widget-editor-content">
        @if (configErrors(); as errors) {
          <div class="widget-editor-errors">
            @for (error of errors; track $index) {
              <p>{{ error }}</p>
            }
          </div>
        }
        @if (editorMode() === 'visual' && isGraphpad() && graphpadConfig(); as gpConfig) {
          <div class="widget-editor-body">
            <dojo-graphpad-editor [config]="gpConfig" (configChange)="onVisualEditorChange($event)" />
          </div>
        } @else if (editorMode() === 'visual' && isGeometrypad()) {
          <div class="widget-editor-body">
            <dojo-geometrypad-editor [config]="geometrypadConfig()!" (configChange)="onVisualEditorChange($event)" />
          </div>
        } @else {
          <div class="widget-editor-body">
            <dojo-json-editor [formCtrl]="configControl" />
          </div>
        }
      </div>
    </dojo-draggable-pane>
  </div>
}
